const _ = require('lodash');

class RelatedProductController {
    constructor(trolleyService, shopPageStateService, $rootScope, $stateParams, settingsService, bwsNotificationService, collectionTimeService, atm) {
        this.$onInit = function() {
            this.shopPageStateService = shopPageStateService;
            this.$stateParams = $stateParams;
            this.trolleyService = trolleyService;
            this.productBadge = null;
            this.atm = atm;
            this.bwsNotificationService = bwsNotificationService;
            if (this.product.CentreTag) {
                this.hasTag = !!this.product.CentreTag.TagContent;
            }

            this.showPriceInBadge = this.product.IsOnSpecial;
            this.showTagInBadge = this.hasTag;
            this.backOrderCollectionTime = collectionTimeService.calculateBackorderPickupDate();

            // check if product is in a restricted category
            if (this.product && this.product.ProductData && this.product.ProductData.categoryleafnodeid) {
                settingsService.getSettingValue('ProductRestrictions', 'CategoryIds').then((restrictedCategories) => {
                    this.isInRestrictedCategory = (_.intersection(restrictedCategories, this.product.ProductData.categoryleafnodeid.map(id => id.toString())).length > 0);
                });
            }

            if (this.product) {
                if (this.product.ProductData && this.product.ProductData.productbadgeoverride) {
                    this.productBadge = this.product.ProductData.productbadgeoverride;
                } else if (this.product.ImageTag.TagContent) {
                    this.productBadge = this.product.ImageTag.TagContent;
                }
            }
        };
    }

    addToTrolley() {

        if (!this.product.IsInTrolley) {
            let previousCrossSell;
            if (this.pos) {
                previousCrossSell = this.$stateParams.crossSellType ? '' + this.$stateParams.crossSellType : null;
                this.$stateParams.crossSellType = 'web:pdp:recommended products on offer:' + this.pos;
            }

            this.isAddingToTrolley = true;
            this.product.IsInTrolley = true;

            this.trolleyService
                .addItemToTrolley(this.product, this.product.QuantityInTrolley + 1, 'Products in same offer')
                .finally(() => {
                    this.isAddingToTrolley = false;
                    this.$stateParams.crossSellType = previousCrossSell;
                });
        }
    }

    openCart() {
        this.shopPageStateService.triggerPanel('right', true, 'product tile overlay');
    }

    addOrOpenCart() {
        if (this.product.IsInTrolley) {
            this.openCart();
        } else {
            this.addToTrolley();
        }
    }

    showSavingsBadge() {
        return (!this.product.HideWasSavedPrice && this.product.SavingsAmount > 0 && !this.isInRistrictedCategory)
            || this.product.PercentageOffTag.SavedAmount > 0 && this.product.PercentageOffTag.TagType !== 'None'
            || this.product.FixedPricePromoTag.SavedAmount > 0 && this.product.FixedPricePromoTag.TagType !== 'None';
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controller: ['TrolleyService', 'ShopPageStateService', '$rootScope', '$stateParams', 'SettingsService', 'BwsNotificationService', 'CollectionTimeService', 'AtmService', RelatedProductController],
        controllerAs: 'ctrl',
        bindToController: {
            product: '=',
            productGroupName: '=',
            pos: '='
        },
        scope: {},
        link(scope) {

            scope.savingsAmount = (scope.ctrl.product.PercentageOffTag.TagType !== 'None' || scope.ctrl.product.FixedPricePromoTag.TagType !== 'None')
                ? (scope.ctrl.product.PercentageOffTag.SavedAmount || scope.ctrl.product.FixedPricePromoTag.SavedAmount)
                : scope.ctrl.product.SavingsAmount;

            scope.$on('trolley:update', (event, trolley) => {
                if ((trolley.type === 'remove' && trolley.product.Stockcode === scope.ctrl.product.Stockcode) || trolley.type === 'clear') {
                    scope.ctrl.product.IsInTrolley = false;
                    scope.ctrl.product.QuantityInTrolley = 0;
                }
            });

        },
        template: require('./related-product-card-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/relatedproducts/related-product-card-directive.js
 **/